import React from 'react';
import { colors, spacing, typography } from '../tokens';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function PageHeader(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    action = _ref.action;
  var containerStyle = {
    fontFamily: typography.fontFamily,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: spacing.lg
  };
  var titleStyle = {
    fontSize: typography.sizes['2xl'],
    fontWeight: 700,
    color: colors.neutral[900],
    margin: 0
  };
  var subtitleStyle = {
    fontSize: typography.sizes.sm,
    color: colors.neutral[500],
    marginTop: spacing.xs
  };
  return /*#__PURE__*/_jsxs("div", {
    style: containerStyle,
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("h1", {
        style: titleStyle,
        children: title
      }), subtitle && /*#__PURE__*/_jsx("p", {
        style: subtitleStyle,
        children: subtitle
      })]
    }), action && /*#__PURE__*/_jsx("div", {
      children: action
    })]
  });
}